<template>
    <div class="auth-header">
        <div class="auth-heading">
            <h1 v-html="props.title ?? ''"></h1>
            <p class="auth-subtext">{{ props.subtitle }}</p>
        </div>
        <div class="brand-icon" v-if="props.showIcon">
            <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none"/>
        </div>
    </div>
</template>

<script setup>

import './PageTitle.scss';
import {defineProps} from 'vue';
import SvgIcon from '@/components/Svg/SvgIcon.vue';

const props = defineProps({
    title: {
        type: String,
        required: true
    },
    subtitle: {
        type: String,
        default: ''
    },
    showIcon: {
        type: Boolean,
        default: false
    }
});

</script>
